import React from "react";
import { useTranslation } from "react-i18next";

interface SubscriberCountProps {
  count: number;
  isLoading: boolean;
  error: string | null;
}

const SubscriberCount: React.FC<SubscriberCountProps> = ({ count, isLoading, error }) => {
  const { t } = useTranslation();

  if (error) {
    // Silently fail - don't show error to user for this non-critical feature
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-gray-400 text-sm">
        <div className="animate-pulse h-4 w-16 bg-gray-600 rounded"></div>
      </div>
    );
  }

  if (count === 0) {
    // Don't show anything if no subscribers
    return null;
  }

  // Format the subscriber text
  const subscriberText = count === 1 
    ? t('subscription.onePersonWatching', '1 person watching')
    : t('subscription.peopleWatching', '{{count}} people watching', { count });

  return (
    <div className="flex items-center gap-2 text-gray-400 text-sm font-medium">
      <span className="text-base">👥</span>
      <span>{subscriberText}</span>
    </div>
  );
};

export default SubscriberCount;